import { Suspense, lazy } from 'react';
import Header from './Headers/Header';
import { Outlet } from 'react-router-dom';
import "react-range-slider-input/dist/style.css";
import OfflineBanner from '../OfflineBanner';
import { SlowNetworkOverlay } from '../PageLoader';
const Footer = lazy(() => import('./Footer'));

const Layout = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-background">
      <OfflineBanner />
      <Header />

      <main style={{minHeight:'100vh'}}  className="bg-light-background dark:bg-dark-background">
        <Outlet />
      </main>
      <Suspense>
        <Footer />
      </Suspense>

      <SlowNetworkOverlay />
    </div>
  );
};

export default Layout;